import React from "react";
import { Link, useLocation } from "react-router-dom";

// Icons for the bottom navigation
const SummaryIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-6 h-6"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 1 1 5.82 1c0 1.5-1.5 2-2 2" />
    <line x1="12" y1="17" x2="12" y2="17" />
  </svg>
);

const HealthIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-6 h-6"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l9 9 9-9a5.5 5.5 0 0 0 0-7.8z" />
    <polyline points="9 11 11 13 15 9" />
  </svg>
);

const ProfileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-6 h-6"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const BottomNavigation = () => {
  const location = useLocation();

  const navItems = [
    {
      path: "/landing/questionanswer",
      icon: <SummaryIcon />,
      label: "Summary",
    },
    {
      path: "/browse-health-categories",
      icon: <HealthIcon />,
      label: "Browse",
    },
    {
      path: "/landing/tab3",
      icon: <ProfileIcon />,
      label: "Profile",
    },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-[#161B22] border-t border-[#30363D] z-50 safe-area-bottom">
      <nav className="flex justify-around">
        {navItems.map((item, index) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={index}
              to={item.path}
              className={`flex flex-col items-center py-3 px-4 flex-1 ${
                isActive
                  ? "text-[#58A6FF] bg-[#21262D]"
                  : "text-white hover:text-[#58A6FF]"
              }`}
            >
              <span
                className={`${
                  isActive ? "text-[#58A6FF]" : "text-white"
                } mb-1`}
              >
                {item.icon}
              </span>
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default BottomNavigation; 